import React, { useState, useEffect } from 'react'
import { EmptyPlaceholder } from '../../../../components/placeholder';
import { priceFormat } from '../../../../utils/common';
import './index.less'
const CHARGE_CDN = 'https://s.xiaopeng.com/xp-charge/mini'

const MemberGoodslist = ({ list, type, onChange, active, label = '', key }: { list: any[]; type?: 'coupon_pack' | 'value_card'; onChange: (data) => void; active: any, label: string, key: string }) => {
   
    if (!type) {
        return <></>
    }
    useEffect(() => {
    }, [active])
    
    return <div className='good-item-list-wrap' key={key}>
        {
            type === 'coupon_pack'
            &&
            <div className='good-item-list-title'>
                <div className='line'></div>
                <div className='dot'></div>
                抵服务费·每单优惠3元·支持100%积分兑换
                <div className='dot'></div>
                <div className='line'></div>
            </div>
        }
        {
            type === 'value_card'
            &&
            <div className='good-item-list-title'>
                <div className='line'></div>
                <div className='dot'></div>
                抵电费和服务费·可叠加充电券·支持100%积分兑换
                <div className='dot'></div>
                <div className='line'></div>
            </div>
        }
        <div className='good-item-list' key={key} onScroll={(e)=>{
            e.preventDefault()
            e.stopPropagation()
        }}>
            {
                list?.length
                    ?
                    list.map((listItem, index) => {
                        return <div
                            className={
                                `good-item
              ${type === 'coupon_pack' ? `coupon-pack-good-item${listItem?.key === active?.key ? '-active' : ''}` : ''} 
              ${type === 'value_card' ? `value-card-good-item${listItem?.key === active?.key ? '-active' : ''}` : ''}
              `
                            }
                            onClick={() => onChange(listItem)}
                            key={`good-${listItem?.spu}-${index}`}
                        >
                            {!!listItem?.showDiscountCouponLabel && label &&
                                <div className='coupon-pack-discount-tag'>
                                    <img className='discount-tag-bg' src={`${CHARGE_CDN}/chargeVip/${type === 'coupon_pack' ? 'coupon_pack_discount_tag_tail2' : 'value_card_discount_tag_tail2'}.png`} alt="" />
                                    <div className='discount-tag-text'>{label}</div>
                                </div>
                            }

                            {
                                type === 'coupon_pack'
                                &&
                                <>
                                    <div className='good-title-wrap'>
                                        <div className='heavy-text'>{listItem?.mainTitle || '--'}</div>
                                        {/* <div className='heavy-text'>3</div>元
                      X
                      <div className='heavy-text'>3</div>张 */}
                                    </div>
                                    <div className='good-price-wrap'
                                        style={
                                            listItem?.showDiscountBuy &&
                                                // 不是小数且长度大于等于4，换行
                                                // 是小数且长度大于等于6，换行 
                                                (
                                                    (!String(priceFormat(listItem?.discountBuyPrice)).includes('.') && String(priceFormat(listItem?.discountBuyPrice)).length >= 4)
                                                    ||
                                                    (String(priceFormat(listItem?.discountBuyPrice)).includes('.') && String(priceFormat(listItem?.discountBuyPrice)).length >= 6)
                                                )
                                                ?
                                                { flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: 0 }
                                                :
                                                {}
                                        }
                                    >
                                        <div className='good-price'>
                                            <div className='big-heavy-text-unit'>¥</div>
                                            <div className='big-heavy-text'>{listItem?.showDiscountBuy ? String(priceFormat(listItem?.discountBuyPrice))?.split('.')?.[0] : String(priceFormat(listItem?.salePrice))?.split('.')[0]}</div>
                                            {
                                                listItem?.showDiscountBuy
                                                    ?
                                                    (!!String(priceFormat(listItem?.discountBuyPrice))?.split('.')?.[1] && <div className='small-heavy-text'>{`.${String(priceFormat(listItem?.discountBuyPrice))?.split('.')?.[1]}`}</div>)
                                                    :
                                                    (!!String(priceFormat(listItem?.salePrice))?.split('.')?.[1] && <div className='small-heavy-text'>{`.${String(priceFormat(listItem?.salePrice))?.split('.')?.[1]}`}</div>)
                                            }
                                        </div>
                                        {!!listItem?.showDiscountBuy && <div className='grey-line-price-text'>¥{priceFormat(listItem?.salePrice)}</div>}
                                    </div>
                                </>
                            }
                            {
                                type === 'value_card'
                                &&
                                <>
                                    <div className='good-title-wrap'>
                                        <div className='value-title'>
                                            {listItem?.mainTitle || '--'}
                                        </div>
                                    </div>

                                    <div className='good-price-wrap'
                                        style={
                                            listItem?.showDiscountBuy &&
                                                // 不是小数且长度大于等于4，换行
                                                // 是小数且长度大于等于6，换行 
                                                (
                                                    (!String(priceFormat(listItem?.discountBuyPrice)).includes('.') && String(priceFormat(listItem?.discountBuyPrice)).length >= 4)
                                                    ||
                                                    (String(priceFormat(listItem?.discountBuyPrice)).includes('.') && String(priceFormat(listItem?.discountBuyPrice)).length >= 6)
                                                )
                                                ?
                                                { flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: 0 }
                                                :
                                                {}
                                        }
                                    >
                                        <div className='good-price'>
                                            <div className='big-heavy-text-unit'>¥</div>
                                            <div className='big-heavy-text'>{listItem?.showDiscountBuy ? String(priceFormat(listItem?.discountBuyPrice))?.split('.')?.[0] : String(priceFormat(listItem?.salePrice))?.split('.')[0]}</div>
                                            {
                                                listItem?.showDiscountBuy
                                                    ?
                                                    (!!String(priceFormat(listItem?.discountBuyPrice))?.split('.')?.[1] && <div className='small-heavy-text'>{`.${String(priceFormat(listItem?.discountBuyPrice))?.split('.')?.[1]}`}</div>)
                                                    :
                                                    (!!String(priceFormat(listItem?.salePrice))?.split('.')?.[1] && <div className='small-heavy-text'>{`.${String(priceFormat(listItem?.salePrice))?.split('.')?.[1]}`}</div>)
                                            }
                                        </div>
                                        {!!listItem?.showDiscountBuy && <div className='grey-line-price-text'>¥{priceFormat(listItem?.salePrice)}</div>}
                                    </div>
                                </>
                            }
                            <div className='good-extra-desc'>
                                {listItem?.subTitle}
                            </div>
                        </div>
                    })
                    :
                    <div className='empty-wrapper'>
                        <EmptyPlaceholder text={'暂无产品'}></EmptyPlaceholder>
                    </div>
            }
        </div>
    </div>
}

export default MemberGoodslist